import { useNavigate, NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";
import profile from "../../assets/profile.png";
import "./Navbar.css";

function Navbar() {
  const navigate = useNavigate();

  const username = sessionStorage.getItem("username");
  const email = sessionStorage.getItem("email");
  const role = sessionStorage.getItem("role");
  const theme = JSON.parse(sessionStorage.getItem("tenantTheme") || "{}");

  const handleClick = () => {
    navigate("/dashboard");
  };

  return (
    <div className="navbar navbar-expand-lg navbar-light sticky-top shadow-sm Navbar h-101 myNavbar">
      {/* Logo */}
      <div
        className="d-flex align-items-center"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <img
          src={theme.logo}
          alt="Logo"
          style={{ height: "50px", paddingLeft: "10px" }}
        />
      </div>

      {/* Mobile toggle button */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Navbar links */}
      <div className="collapse navbar-collapse" id="navbarNav">

        {/* Logo + Nav stay on LEFT */}
        <ul className="navbar-nav me-auto ms-3 gap-3">
          <li className="NavList nav-item">
            <NavLink to="/dashboard" className={({ isActive }) =>
              `nav-link px-3 ${isActive ? "active" : "unActive"}`
            }>
              Dashboard
            </NavLink>
          </li>

          <li className="NavList nav-item">
            <NavLink to="/assignments" className={({ isActive }) =>
              `nav-link px-3 ${isActive ? "active" : "unActive"}`
            }>
              Assignments
            </NavLink>
          </li>

          <li className="NavList nav-item">
            <NavLink to="/assets" className={({ isActive }) =>
              `nav-link px-3 ${isActive ? "active" : "unActive"}`
            }>
              Assets
            </NavLink>
          </li>

          <li className="NavList nav-item">
            <NavLink to="/employees" className={({ isActive }) =>
              `nav-link px-3 ${isActive ? "active" : "unActive"}`
            }>
              Employees
            </NavLink>
          </li>
        </ul>

        {/* Profile dropdown */}
        <div className="dropdown">
          <button
            className="btn dropdown-toggle d-flex align-items-center border p-2 me-2"
            type="button"
            id="profileDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* <p className="profileName text-capitalize mb-0 ">{username}</p> */}
            <div>
              <p className="profileName text-capitalize mb-0 ">{username.charAt(0)}</p>
              {/* <img src={profile} alt="profile" className="proimg p-1" /> */}
            </div>
          </button>

          <ul
            className="dropdown-menu dropdown-menu-end p-3 shadow"
            aria-labelledby="profileDropdown"
            style={{ minWidth: "250px" }}
          >
            <li className="mb-2 fw-bold text-center text-capitalize">
              Hi, {username}
            </li>
            <li className="small text-muted mb-2 text-center">{email}</li>
            <li>
              <hr className="dropdown-divider" />
            </li>

            {/* Change Password (everyone) */}
            <li>
              <button
                className="dropdown-item text-center"
                onClick={() => navigate("/users/change-password")}
              >
                Change Password
              </button>
            </li>

            {/* Reset Password (admin only) */}
            {role === "ROLE_ADMIN" && (
              <li>
                <button
                  className="dropdown-item text-center"
                  onClick={() => navigate("/admin/reset-password")}
                >
                  Reset Password
                </button>
              </li>
            )}

            {/* Sign Out */}
            <li>
              <button
                className="dropdown-item text-center"
                onClick={() => {
                  // window.location.href = "/";
                  const tenantName = sessionStorage.getItem("tenant");
                  sessionStorage.clear();

                  // Redirect to tenant login
                  window.location.href = tenantName
                    ? `/login/${tenantName}`
                    : "/";

                }}
              >
                Sign Out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
